<atn-ds-table [config]="usersTableConfig" />

<atn-admin-user-assignment-modal />
<atn-admin-user-modal />

@let markedUserForUnassignment =
  userAssignmentFeature.selectors.markedUserForUnassignment.asSignal();
@if (markedUserForUnassignment) {
  @let mutationError =
    userAssignmentFeature.selectors.mutationErrorMessage.asSignal();
  <atn-ds-confirmation-overlay
    title="Unassign User"
    [description]="
      'Unassigning ' +
      markedUserForUnassignment.name +
      ' from this tenant can\'t be undone. Are you sure you want to continue?'
    "
    [error]="mutationError"
    (cancel)="cancelUnassignmentClickHandler()"
    (confirm)="confirmUnassignmentClickHandler()"
    confirmButtonText="Confirm"
  />
}

@if (usersEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal()) {
  @let deletionError =
    usersEc.plugins.editingPlugin.feature.selectors.submissionError.asSignal();
  <atn-ds-confirmation-overlay
    title="Delete User"
    [description]="deleteConfirmationTextSg()"
    [error]="deletionError"
    [validation]="deletingUserNameSg()"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
    confirmButtonText="Delete"
  />
}
